module.exports = __webpack_public_path__ + "img/icon-toggle-check-box_off.a8558013.svg";